// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
	text-align: center;
	margin-top: 10px;
}

.emphasis {
	font-weight: bold;
}

.title {
	font-family: MuseoSans-500;
	font-size: 24px;
	color: #15325F;
	letter-spacing: 0.01px;
	margin-bottom: 10px;
}

.description:last-of-type {
  margin-top: 16px;
	margin-bottom: 36px;
}

:host >>> .description span {
	font-family: MuseoSans-500;
}

button {
	width: 200px;
	margin-top: 4px;
	margin-bottom: 24px;
}

:host >>> a {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #00A1E0;
}

.description {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #1C1D1D;
  letter-spacing: 0.01px;
  line-height: 1.25;
}

.checkbox-container {
  margin-right: 32px;
  margin-left: 32px;
}

span.info > img {
	margin-top: 8px;
}

img.img-checkbox {
  cursor: pointer;
}

.checkbox {
  padding-right: 0;
}

.check-box-text-container {
  padding-left: 0;
  margin-top: 5px;
  text-align: left;
}

.check-box-text {
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #1C1D1D;
  letter-spacing: 0.01px;
  line-height: 1.25;
  word-break: break-word;
}

.text-danger {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #ED1C24;
  text-align: center;
  margin-top: -20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/gateway-connection/gateway-connection.component.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;EACE,gBAAgB;CACjB,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;EACb,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".content {\n\ttext-align: center;\n\tmargin-top: 10px;\n}\n\n.emphasis {\n\tfont-weight: bold;\n}\n\n.title {\n\tfont-family: MuseoSans-500;\n\tfont-size: 24px;\n\tcolor: #15325F;\n\tletter-spacing: 0.01px;\n\tmargin-bottom: 10px;\n}\n\n.description:last-of-type {\n  margin-top: 16px;\n\tmargin-bottom: 36px;\n}\n\n:host >>> .description span {\n\tfont-family: MuseoSans-500;\n}\n\nbutton {\n\twidth: 200px;\n\tmargin-top: 4px;\n\tmargin-bottom: 24px;\n}\n\n:host >>> a {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #00A1E0;\n}\n\n.description {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #1C1D1D;\n  letter-spacing: 0.01px;\n  line-height: 1.25;\n}\n\n.checkbox-container {\n  margin-right: 32px;\n  margin-left: 32px;\n}\n\nspan.info > img {\n\tmargin-top: 8px;\n}\n\nimg.img-checkbox {\n  cursor: pointer;\n}\n\n.checkbox {\n  padding-right: 0;\n}\n\n.check-box-text-container {\n  padding-left: 0;\n  margin-top: 5px;\n  text-align: left;\n}\n\n.check-box-text {\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #1C1D1D;\n  letter-spacing: 0.01px;\n  line-height: 1.25;\n  word-break: break-word;\n}\n\n.text-danger {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #ED1C24;\n  text-align: center;\n  margin-top: -20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
